import { Fragment } from 'react';
import { Breakpoints, LoaderType, NextgenImage, useBreakpoint } from '@nextgen-web-framework/all';
import { HighlightsCData, HighlightsCProps } from './types/propTypes';
import styles from './HighlightsC.module.scss';

const HighlightsC = (props: HighlightsCProps) => {
  const viewPortType = useBreakpoint();
  const { features } = props;
  return (
    <div className={styles['highlightsC-container']} data-testid={'highlightsC-test-id'}>
      {features.map((data, index: number) => (
        <Fragment key={data.displayTitle}>
          {viewPortType === Breakpoints.MD
            ? index % 2 === 0 && (
                <div className={styles['highlightsC-design-row']}>
                  {highlightsCItem(features[index])}
                  {index < features.length && highlightsCItem(features[index + 1])}
                </div>
              )
            : highlightsCItem(data)}
        </Fragment>
      ))}
    </div>
  );
};

const highlightsCItem = (data: HighlightsCData) => (
  <div className={styles['highlightsC-design-container']}>
    <div className={styles['highlightsC-design-left-wrapper']}>
      <div className={styles['highlightsC-design-image-wrapper']}>
        <NextgenImage loaderType={LoaderType.CONTENTSTACK} src={data.image.url} alt={data.image.altText} />
      </div>
    </div>
    <div className={styles['highlightsC-design-right-wrapper']}>
      <div className={styles['highlightsC-title']}>{data.displayTitle}</div>
      <div className={styles['highlightsC-subtitle']}>{data.subTitle}</div>
    </div>
  </div>
);
export default HighlightsC;
